export default {
  /**
   * Função responsável por validar se o usuário possui a permissão de acesso á página
   * @returns (true) -> Possui permissão
   * @returns (false) -> Não possui permissão
   */
   validaAcesso(arrPermissao) {
    let dados = JSON.parse(localStorage.getItem("login"));
    if (dados) {
      let perfils = dados.perfil
  
      let permissoes = [];
      arrPermissao.forEach(ap => {
        perfils.forEach(p => {
          if (ap === p.NomePerfil)
            permissoes.push(ap)
        })
      })
  
      return permissoes.length > 0;
    }
  }
}